import { apiClient } from './client';

export interface ConfigTemplate {
  id: number;
  template_type: string;
  name: string;
  data: Record<string, unknown>;
  created_at: string;
}

export const templatesApi = {
  list: (templateType: string) =>
    apiClient.get<ConfigTemplate[]>('/api/templates', { params: { template_type: templateType } }),
  create: (templateType: string, name: string, data: Record<string, unknown>) =>
    apiClient.post<ConfigTemplate>('/api/templates', { template_type: templateType, name, data }),
  remove: (id: number) => apiClient.delete(`/api/templates/${id}`),
};
